/**
 * @generated SignedSource<<f29b4a0584cb919834b894aa95f346c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PullRequestAndBranchPickerBranch$data = {
  readonly id: string;
  readonly isDraft: boolean;
  readonly number: number;
  readonly repository: {
    readonly id: string;
    readonly name: string;
    readonly nameWithOwner: string;
    readonly owner: {
      readonly __typename: string;
      readonly login: string;
    };
  };
  readonly state: PullRequestState;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "PullRequestAndBranchPickerBranch";
};
export type PullRequestAndBranchPickerBranch$key = {
  readonly " $data"?: PullRequestAndBranchPickerBranch$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestAndBranchPickerBranch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PullRequestAndBranchPickerBranch"
};

(node as any).hash = "08f8e6595e3c3372df6e6f348e53e2c9";

export default node;
